import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Maintenance from './views/Maintenance.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/webprint/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },{
      path: '/:spot',
      name: 'spot',
      component: Home
    },{
      path: '/maintenance',
	  name: 'maintenance',
	  component: Maintenance
	}
  ]
})
